import _ from 'underscore';

export const getBidStrategyMap = _.memoize(() => ({
  MaxClicks: _TL_('Maximize clicks'),
  MaxConversions: _TL_('Maximize conversions'),
  MaxConversionValue: _TL_('Maximize conversion value'),
  MaxImpressions: _TL_('Maximize impressions'),
  MaxReach: _TL_('Maximize reach'),
  ManualCpa: _TL_('CPI (cost per install)'),
  ManualCpm: _TL_('CPM (cost per thousand impressions) for maximizing reach'),
  ManualCpv: _TL_('CPCV (cost per completed view)'),
  ManualCpc: _TL_('CPC (cost per click)'),
  EnhancedCpc: _TL_('Enhanced CPC (enhanced cost per click)'),
  CostPerSale: _TL_('Cost per Sale'),
  TargetRoas: _TL_('Target ROAS'),
  TargetCpa: _TL_('Target CPA'),
  TargetImpressionShare: _TL_('Target impression share'),
}));

export const getBidTitleDetails = (i18n, bid) => {
  if (!bid || !getBidStrategyMap()[bid.Type]) {
    return '';
  }

  return i18n.getString(getBidStrategyMap()[bid.Type]);
};

export const getBidBudgetTitleDetails = (serverContext, i18n, bid, budget) => {
  const currencyCode = serverContext.CurrentAccount.CurrencyCode;
  const amount = _.isNumber(budget.Amount) ?
    i18n.formatCurrency(budget.Amount, currencyCode) :
    '-';
  const bidType = getBidTitleDetails(i18n, bid);
  let bidVal = '';
  if (bid.TargetCpa) {
    bidVal = i18n.formatCurrency(bid.TargetCpa, currencyCode);
  }
  if (bid.TargetRoas) {
    bidVal = i18n.formatPercent(bid.TargetRoas);
  }
  return i18n.getString(_TL_('{{amount}} per day; {{bidType}}, default CPA {{bidVal}}'), {
    amount, bidType, bidVal,
  });
};

export const getBudgetTitleDetails = (serverContext, i18n, budget) => {
  const currencyCode = serverContext.CurrentAccount.CurrencyCode;
  const amount = _.isNumber(budget && budget.Amount) ?
    i18n.formatCurrency(budget.Amount, currencyCode) :
    '-';
  return i18n.getString(_TL_('{{amount}} per day'), {
    amount,
  });
};
